var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-string',{attrs:{"label-id":_vm.labelId,"props":_vm.textStringProps}})}
var staticRenderFns = []

export { render, staticRenderFns }